export default __webpack_public_path__ + "static/media/mlb_compress_header.a9c0689b.jpg";